export default "__VITE_ASSET__DMXOUPvc__"